import React from "react";
import Anchor from "@atom/Anchor";
import ProgressiveImage from "@atom/ProgressiveImage";
import { Heading, LabelwithEmphasis } from "@atom/Typography";
import style from "./style.scss";
import cn from "classnames";

export default ({ img, title, subtitle, link }) => (
  <div className={cn(style.pdfPreview)} onClick={() => window.open(link)}>
    <ProgressiveImage {...img} className={cn(style.img)} />
    <Heading type={"h3"} weight={900}>
      {title}
    </Heading>
    {subtitle && (
      <LabelwithEmphasis className={cn(style.subtitle)}>
        {subtitle}
      </LabelwithEmphasis>
    )}
  </div>
);
